// extracted by mini-css-extract-plugin
export default {"hidden":"alIgD9"};